import { render, staticRenderFns } from "./PopUpTitle.vue?vue&type=template&id=3aaedd34&scoped=true"
import script from "./PopUpTitle.vue?vue&type=script&lang=ts"
export * from "./PopUpTitle.vue?vue&type=script&lang=ts"
import style0 from "./PopUpTitle.vue?vue&type=style&index=0&id=3aaedd34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaedd34",
  null
  
)

export default component.exports